import script from "./SimpleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleModal.vue?vue&type=script&setup=true&lang=js"

import "./SimpleModal.vue?vue&type=style&index=0&id=b7ae7992&lang=scss"

const __exports__ = script;

export default __exports__